import { StateCreator } from "zustand";
import { darkTheme } from "../../styles/themes/dark";
import { lightTheme } from "../../styles/themes/light";
import {
  AuthSlice,
  MessageSlice,
  ThemeSlice,
  RegisterSlice,
  SectionSlice,
  OptionSlice,
  OrganizationSlice,
} from "../../interfaces";

const getInitialTheme = () => {
  const prefersDarkScheme = window.matchMedia(
    "(prefers-color-scheme: dark)"
  ).matches;
  return prefersDarkScheme ? darkTheme : lightTheme;
};

export const createThemeSlice: StateCreator<
  RegisterSlice &
    SectionSlice &
    MessageSlice &
    AuthSlice &
    OptionSlice &
    OrganizationSlice &
    ThemeSlice,
  [["zustand/persist", unknown]],
  [],
  ThemeSlice
> = (set) => {
  return {
    themeZustand: getInitialTheme(),
    toggleTheme: () =>
      set((state) => ({
        themeZustand:
          state.themeZustand.title === "light" ? darkTheme : lightTheme,
      })),
  };
};
